import { parseAbi } from "viem";

export const nftAbi = parseAbi([
  "function whitelistMint() external payable",
  "function totalSupply() external view returns (uint256)",
]);
